/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Library_QuestionInputs */

const en_landing_faq_library_question = /** @type {(inputs: Landing_Faq_Library_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I use my existing research library with Inginuiti?`)
};

/**
* | output |
* | --- |
* | "How do I use my existing research library with Inginuiti?" |
*
* @param {Landing_Faq_Library_QuestionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_faq_library_question = /** @type {((inputs?: Landing_Faq_Library_QuestionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Library_QuestionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_faq_library_question(inputs)
});